import React from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from "reactstrap";

const ConfirmModal = ({ isOpen, toggle, title = "Confirm Action", message = "Are you sure?", confirmText = "Confirm", cancelText = "Cancel", onConfirm, loading = false, }) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>{title}</ModalHeader>

      <ModalBody>
        <p className="mb-0">{message}</p>
      </ModalBody>

      <ModalFooter>
        <Button color="secondary" onClick={toggle} disabled={loading}>
          {cancelText}
        </Button>

        <Button color="danger" onClick={onConfirm} disabled={loading}>
          {loading ? "Please wait..." : confirmText}
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default ConfirmModal;